import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { CloseButton } from '@leroy-merlin-br/backyard-react-ui'

const closeIconStyles = ({ theme }) => css`
  label: employee-notification__close-icon;
  color: ${theme.colors.white};
  font-size: ${theme.typography.text.mega.fontSize};
  line-height: 1;
  position: absolute;
  top: 0;
  right: 0;
`

const wrapperStyles = ({ theme }) => css`
  label: employee-notification__wrapper;
  background-color: ${theme.colors.p700};
  color: ${theme.colors.white};
  display: flex;
  justify-content: center;
  margin-top: ${theme.spacings.kilo};
  padding: ${theme.spacings.giga} ${theme.spacings.mega};
  position: absolute;
  left: 0;
  right: 0;
  z-index: ${theme.zIndex.backdrop};

  ${theme.media.giga} {
    margin-top: 130px;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const CloseIcon = styled(CloseButton)(closeIconStyles)
